import { render } from "./AddBlStep2Page.vue?vue&type=template&id=1bb1a8a1&ts=true"
import script from "./AddBlStep2Page.vue?vue&type=script&lang=ts"
export * from "./AddBlStep2Page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__